// extracted by mini-css-extract-plugin
export default {"Month":"CZcxD","title-wrap":"tiRCx","title":"Z-zFl","year":"_4UMkD","skeleton-progress":"gujQP"};